/*
 * This file is part of glowingblue/orell-rezensionen.
 *
 * Copyright (c) Glowing Blue AG.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Extend from 'flarum/common/extenders';
import Discussion from 'flarum/common/models/Discussion';
import User from 'flarum/common/models/User';
import Article from 'flarum/orell-articles/models/Article';
import Review from './models/Review';

/** Applied by `bootExtensions()`, before any initializer. Typed in `@types/modules.d.ts`. */
export default [
	new Extend.Store() //
		.add('gb_reviews', Review),

	new Extend.Model(Discussion) //
		.hasOne<Review>('review')
		.attribute<boolean>('isReview')
		.attribute<boolean>('canEditReview')
		.attribute<boolean>('selectedForExport'),

	new Extend.Model(User) //
		.attribute<boolean>('canCreateReviews')
		.attribute<number>('reviewCount')
		.attribute<number>('recentReviewsCount'),

	new Extend.Model(Article) //
		.attribute<number>('rating')
		.attribute<number>('recentRatingAvg')
		.attribute<number>('reviewCount')
		.attribute<number>('ratingCount')
		.attribute<number>('allReviewsCount')
		.hasOne<Review>('ownReview')
		.attribute<number>('rated5')
		.attribute<number>('rated4')
		.attribute<number>('rated3')
		.attribute<number>('rated2')
		.attribute<number>('rated1'),
];
